import React from 'react'
import Cookies from "universal-cookie";

const cookies = new Cookies();

async function qlikAuth(userToken) {
  var options = {
    method: "GET",
    headers: { Authorization: userToken },
  };

  const res = await fetch(process.env.REACT_APP_QLIK_API + "ticket", options)
  if (res.ok) {
    return res.json()
  }
  return null
}

async function qlikLogout(userToken) {
  var options = {
    method: "GET",
    headers: { Authorization: userToken },
  };

  await fetch(process.env.REACT_APP_QLIK_API + "logout?cookie=" + cookies.get("X-Qlik-Session-CMP"), options)
}

export default class ServiceInterval extends React.Component {
  componentDidMount() {
    this.intervalId = setInterval(async () => {
      // Check if the user has authenticated for qlik
      console.log("SERVICE WORKER -", new Date().toLocaleTimeString())
      const qlikAuthToken = window.localStorage.getItem("cmpQlikToken")
      if (!qlikAuthToken) {
        console.log("SERVICE WORKER - No Auth")
        return
      }

      // Check to see what the current exp time is
      const qlikExp = window.localStorage.getItem("qlikExp")
      if (!qlikExp) {
        console.log("SERVICE WORKER - No Qlik Exp")
        return
      }

      // If current time < experation time then return
      if ((new Date()).getTime() < parseInt(qlikExp)) {
        console.log("SERVICE WORKER - Exp > NOW")
        return
      }

      console.log("SERVICE WORKER - Logout Current User")
      await qlikLogout(qlikAuthToken)

      console.log("SERVICE WORKER - Fetch Ticket")
      // Fetch new Qlik token
      const result = await qlikAuth(qlikAuthToken)

      if (!result) {
        console.log("ERROR WITH QLIK TICKET")
        return
      }

      var qlik = result["Set-Cookie"].split("=")[1];
      var qlikSession = qlik.split("; ")[0];

      // Configure Exp Time
      var currentDate = new Date();
      currentDate.setHours(currentDate.getHours() + 1);

      cookies.set("Qlik-Ticket-CMP", result["ticket"], {
        path: "/",
        expires: currentDate,
        domain: ".cmp.io",
      });

      cookies.set("X-Qlik-Session-CMP", qlikSession, {
        path: "/",
        expires: currentDate,
        domain: ".cmp.io",
      });

      window.localStorage.setItem("cookie", result["cookie"]);
      window.localStorage.setItem("ticket", result["ticket"]);
      window.localStorage.setItem("qlikExp", currentDate.getTime() - 1.8e+6) // 30 Minutes before the exp time

      // Check if the current page is insights reload
      if (window.location.href.includes("/insights/")) {
        window.location.reload();
      }
    }, 15000)
  }

  componentWillUnmount() {
    clearInterval(this.intervalId)
  }

  render() {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/qlikAuth.js